module.exports = __webpack_public_path__ + "assets/img/on4-7d3e342f.png";